import React from "react";
import { Table } from "@redriver/cinnamon";
import EditBoilerPlateModal from "./EditBoilerPlateModal";
import RemoveBoilerPlateModal from "./RemoveBoilerPlateModal";
import MakeBoilerPlateLiveModal from "./MakeBoilerPlateLiveModal";

const BoilerPlateActions = ({ dealerId, item, onSubmitted }) => {
  return (
    <Table.Menu openOnHover>
      <EditBoilerPlateModal
        dealerId={dealerId}
        id={item.id}
        onUpdated={onSubmitted}
        reference={item.reference}
      >
        Edit
      </EditBoilerPlateModal>
      <RemoveBoilerPlateModal
        dealerId={dealerId}
        id={item.id}
        onDeleted={onSubmitted}
        reference={item.reference}
      >
        Delete
      </RemoveBoilerPlateModal>
      {item.isApproved && !item.isLive && (
        <MakeBoilerPlateLiveModal
          id={item.id}
          dealerId={dealerId}
          onSubmitted={onSubmitted}
          reference={item.reference}
        >
          Make Live
        </MakeBoilerPlateLiveModal>
      )}
    </Table.Menu>
  );
};

export default BoilerPlateActions;
